
export const Image_URL = 'https://node.automatedpricingtool.io:5000/images/';
export const Url = 'https://node.automatedpricingtool.io:5000/';





